<div class="list__card-rarity rarity "
  [ngClass]="{'common': creature.rarity == rarityType.Common, 'rare': creature.rarity == rarityType.Rare, 'legendary': creature.rarity == rarityType.Legendary}">
  {{creature.rarity | rarityName | translate}}</div>
<img class="list__card-img" [src]="creature.imageUrl" alt="person1" />
<div class="list__card-info">
  <div class="list__card-left">
    <div class="list__card-name">{{creature.type | creatureType | translate}}</div>
    <div class="list__card-id">{{creature.nftTokenId}}</div>
    <div class="list__card-time" *ngIf="creature.tradeListing">{{creature.tradeListing!.createdAt| timeAgo}}</div>
  </div>
  <div class="list__card-right">
    <div class="list__card-score">#{{creature.nftBatchIndex + 1 }}/{{creature.nftBatchSize}}</div>
    @if(creature.tradeListing){
    <div class="list__card-pol">
      {{creature.tradeListing.price}} <span>ETH</span>
    </div>
    <div class="list__card-price">
      {{creature.tradeListing.price | ethPrice}} <span>USD</span>
    </div>
    }
  </div>
</div>